import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import escudoIcon from '../../../icons/CORAZON ESCUDO - FARMACOVIGILANCIA.gif';
import iconCerrar from '../../../icons/cancelar.png';
import { productosModal } from '../../../utils';
import '../styles/FarmacoModal.css';

const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'none',
    borderRadius: '8px',
    fontFamily: 'inherit',
    fontSize: '11px',
    color: '#333',
    padding: 0,
    minHeight: 'auto',
    boxShadow: state.isFocused ? '0 0 0 2px #aaa' : 'none',
    '&:hover': {
      borderColor: 'transparent',
      boxShadow: state.isFocused ? '0 0 0 2px #aaa' : 'none',
    },
  }),
  input: provided => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '20px',
    color: '#333',
    margin: 0,
    padding: 0,
  }),
  placeholder: provided => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '11px',
    color: '#666',
    margin: 0,
    padding: 0,
  }),
  singleValue: provided => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '11px',
    color: '#333',
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '11px',
    color: '#333',
    backgroundColor: state.isFocused ? '#eee' : '#fff',
    padding: '8px 11px',
    cursor: 'pointer',
  }),
  menu: provided => ({
    ...provided,
    fontFamily: 'inherit',
    fontSize: '11px',
    zIndex: 9999,
  }),
  menuList: provided => ({
    ...provided,
    maxHeight: 108,
  }),
  dropdownIndicator: provided => ({
    ...provided,
    padding: '0 8px',
  }),
  clearIndicator: provided => ({
    ...provided,
    padding: '0 8px',
  }),
  valueContainer: provided => ({
    ...provided,
    padding: '0 8px',
  }),
};

const FarmacoModal = ({ visible, onClose }) => {
  const [step, setStep] = useState('inicio');
  const [selectedMedicamento, setSelectedMedicamento] = useState(null);

  useEffect(() => {
    if (visible) {
      setStep('inicio');
      setSelectedMedicamento(null);
    }
  }, [visible]);

  if (!visible) return null;

  // usando un select que tiene react para manejar mejor
  const opcionesMedicamentos = productosModal.map(medicamento => ({
    value: medicamento,
    label: medicamento,
  }));

  const renderContent = () => {
    switch (step) {
      case 'inicio':
        return (
          <div className="farmaco-layout">
            <div className="farmaco-icono-columna">
              <img
                src={escudoIcon}
                loading="lazy"
                alt="Icono"
                className="farmaco-icono-inicio"
              />
            </div>
            <div className="farmaco-formulario-columna">
              <div className="farmaco-header">
                <h2 className="farmaco-titulo-inicio">
                  Farmaco<span className="bold">vigilancia</span>
                </h2>
                <p className="farmaco-titulo-principal-inicio">
                  ¿Cómo reportar un evento adverso?
                </p>
                <p className="farmaco-subtitulo-explicativo-inicio">
                  Si experimentas o detectas algún posible evento adverso con
                  alguno
                  <br />
                  de nuestros productos, te invitamos a llenar el siguiente
                  formulario
                </p>
              </div>
              <div className="farmaco-form">
                <input type="text" placeholder="Nombre y Apellido" />
                <input type="text" placeholder="Teléfono" />

                {/* React Select para medicamentos */}
                <ReactSelect
                  options={opcionesMedicamentos}
                  value={selectedMedicamento}
                  onChange={setSelectedMedicamento}
                  placeholder="Seleccione un medicamento"
                  isClearable
                  styles={customSelectStyles}
                />

                <input type="text" placeholder="Número de lote" />
                <textarea placeholder="Descripción detallada del evento adverso ocurrido, por favor describa: Qué le ocurrió, Cuándo comenzó, Si tomó algún otro medicamento o remedio, si se recuperó." />
              </div>
              <div className="farmaco-buttons">
                <button
                  className="btn-enviar"
                  onClick={() => setStep('enviado')}
                >
                  <span className="bold">Enviar</span> reporte
                </button>
                <button
                  className="btn-soporte"
                  onClick={() => setStep('soporte')}
                >
                  Soporte <span className="bold">al consumidor</span>
                </button>
              </div>
            </div>
          </div>
        );

      case 'enviado':
        return (
          <div className="farmaco-header-enviado">
            <h2 className="farmaco-titulo-enviado">
              Farmaco<span className="bold">vigilancia</span>
            </h2>
            <br />
            <img
              src={escudoIcon}
              alt="Escudo"
              className="farmaco-icono-enviado"
            />
            <h2 className="farmaco-subtitulo-enviado">
              <br />
              Reporte <span className="bold">enviado</span>
            </h2>
            <p className="farmaco-mensaje-gracias-enviado">
              En la brevedad posible se contactará uno de nuestros
              profesionales.
              <br />
              Gracias por su tiempo.
            </p>
          </div>
        );

      case 'soporte':
        return (
          <div className="farmaco-layout">
            <div className="farmaco-icono-columna">
              <img
                src={escudoIcon}
                loading="lazy"
                alt="Icono"
                className="farmaco-icono-soporte"
              />
            </div>
            <div className="farmaco-formulario-columna-consumidor">
              <div className="farmaco-header">
                <h2 className="farmaco-titulo-soporte">
                  Farmaco<span className="bold">vigilancia</span>
                </h2>
                <p className="farmaco-subtitulo-soporte">
                  Soporte al consumidor
                </p>
              </div>
              <div className="farmaco-form">
                <input type="text" placeholder="Nombre" />
                <input type="text" placeholder="Correo" />
                <textarea placeholder="Escriba su mensaje..." />
              </div>
              <button
                className="btn-enviar btn-solicitar-full"
                onClick={() => setStep('soporteEnviado')}
              >
                SOLICITAR
              </button>
            </div>
          </div>
        );

      case 'soporteEnviado':
        return (
          <div className="farmaco-header-soporteEnviado">
            <h2 className="farmaco-titulo-soporte-enviado">
              Farmaco<span className="bold">vigilancia</span>
            </h2>
            <br />
            <img
              src={escudoIcon}
              alt="Escudo"
              className="farmaco-icono-soporte-enviado"
            />
            <h2 className="farmaco-subtitulo-soporte-enviado">
              <br />
              Solicitud <span className="bold">enviada</span>
            </h2>
            <p className="farmaco-mensaje-gracias-soporte-enviado">
              En breve será contactado por un profesional.
              <br />
              Gracias por su tiempo.
            </p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <div className="farmaco-modal-overlay">
      <div className="farmaco-modal">
        <img
          src={iconCerrar}
          loading="lazy"
          alt="Cerrar"
          className="farmaco-close-icon"
          onClick={onClose}
        />
        {renderContent()}
      </div>
    </div>
  );
};

export default FarmacoModal;
